/* トップKVの fadein ギミック（旧テーマの .fadein/.scrollin を vanilla で再現） */
(function () {
  function reveal() {
    var els = document.querySelectorAll('.fadein:not(.scrollin)');
    var winH = window.innerHeight;
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.top < winH - 100) els[i].classList.add('scrollin');
    }
  }
  window.addEventListener('scroll', reveal, { passive: true });
  window.addEventListener('load', reveal);
  if (document.readyState !== 'loading') setTimeout(reveal, 50);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(reveal, 50); });
})();
